// extracted by mini-css-extract-plugin
export var alignCenter = "_91-d";
export var bannerShown = "_91-6";
export var buttonContent = "_91-0";
export var cardList = "_91-1";
export var centerContent = "_91-2";
export var chevron = "_91-3";
export var closePanelButton = "_91-k";
export var conversationContextContainer = "_91-l";
export var conversationDetailContainer = "_91-4";
export var detailWrapper = "_91-7";
export var dropdownButton = "_91-e";
export var dropdownTitle = "_91-9";
export var fullHeight = "_91-5";
export var hidden = "_91-a";
export var icon = "_91-b";
export var mergeSuggestionWrapper = "_91-m";
export var panel = "_91-i";
export var portalButtonsWrapper = "_91-c";
export var right = "_91-j";
export var tableSummaryContainer = "_91-8";
export var tableSummaryHeader = "_91-g";
export var threeDotsButton = "_91-f";
export var wide = "_91-h";